/**
 * 点击复制到剪切板中 使用execCommand API
 * https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript/30810322#30810322
 * @param {string} text 要复制的内容
 * @return {promise} new promise
 */
import { get_query_by_name, ft, whichOS, isInAPP} from 'hrg-fe-utils';


export const fallbackCopyTextToClipboard = text => {
  let textArea = document.createElement("textarea");
  let root = document.getElementById("root");
  textArea.value = text;
  // document.body.appendChild(textArea);
  document.body.insertBefore(textArea, root);
  
  // textArea.focus();
  textArea.select();
  textArea.setSelectionRange(0, 999999); //不设置的话ios 会有问题
  return new Promise((reslove, reject) => {
      try {
          let success = document.execCommand("copy", true);
          let msg = success ? "success" : "unsuccess";
          reslove(msg);
      } catch (err) {
          reject(err);
      }
      document.body.removeChild(textArea);
  });
};

/**
 * 点击复制到剪切板中 使用 navigator.clipboard.writeText(text)
 * @param {string} text 要复制的内容
 * @return {promise} new promise
 */

export const copyTextToClipboard = text => {
  if (!navigator.clipboard) {
      return fallbackCopyTextToClipboard(text);
  }
  return new Promise((reslove, reject) => {
      navigator.clipboard.writeText(text).then(
          function() {
              reslove("success");
          },
          function(err) {
              reject(err);
          }
      );
  });
};

  // 判断平台
  // var inBrowser = typeof window !== "undefined";
  // var UA = inBrowser && window.navigator.userAgent.toLowerCase();
  // var isWeiXin = UA && /micromessenger/.test(UA);

  export const judgePlatformc =  () => {
    let plat = 'm' // m、app、wx
    var inBrowser = typeof window !== "undefined";
    var UA = inBrowser && window.navigator.userAgent.toLowerCase();

    if (/wuba/.test(UA)){
      plat = 'app'
    } else {
      if (UA && /micromessenger/.test(UA)) {
        plat = 'wx'
      } else {
        plat = 'm'
      }
    }
    return plat;
  }



let share = {
  'magicDay': {
    h1:'我正在参加神奇求职季，签到得现金红包，快去抢~',
    h2:'最高可得128元礼包哦~活动100%真实'
  }
}
      

let images = {
  'magicDay': 'https://pic1.58cdn.com.cn/nowater/cxnomark/n_v285cf1a5ca4ea45ed90e2023d03ad3228.png',
}
  
const placeholderStr = Math.ceil(Math.random() * 600000);
let shareUrl = {
  'magicDay': `https://zp.58.com/yy/2021/magic/special/index/${placeholderStr}`
}
  
// weixin分享
export function shareWeiXin(url,callBack) {
  // console.log('微信分享设置成功！')
  window.wxjs&&window.wxjs.ready((api)=>{
    api.share.set({
      title: share[url].h1,
      desc: share[url].h2,
      link: shareUrl[url],
      imgUrl:images[url],
      success: function () {
        callBack && callBack()
      },
    })
  })
}

// 58app内分享活动链接
export function shareWB (url) {
  try {
    // 分享链接
    window.WBAPP.action.share([{
      shareto:'WEIXIN' ,
      url: shareUrl[url],
      title: share[url].h1,
      content: share[url].h2,
      img_url: images[url],
    },{
      shareto:'FRIENDS' ,
      url: shareUrl[url] ,
      title: share[url].h1,
      content: share[url].h2,
      img_url: images[url],
    }], function(state,source){
      // console.log('分享结果：', state, source)
    })
  } catch (err) {
    // console.log(err)
  }
}


// 是否到第二屏
export const isSecondScreen = () => {
  let body = document.body;
  let scrollTop = body.scrollTop || document.documentElement.scrollTop;
  // let scrollHeight = body.scrollHeight;
  let windowHeight = window.innerHeight/3;
  return scrollTop > windowHeight;
}


/**
 * M端埋点定义
 */
 export const setMLog = (action) => {
  if (action) {
    window.clickLog &&
      window.clickLog(`from=${action}`);
  }
};

// url添加参数
export function updateQueryStringParameter(uri, key, value) {
  if (!value) {
    return uri;
  }
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return uri + separator + key + "=" + value;
  }
}


/**
 * 直调 默认调到主页 paramsObj.url协议
 * <script src="//j1.58cdn.com.cn/ztzp/2019/m/static/js/wxjs.js"></script>
 * <script src="//down.58.com/js/callWbApp_2019_min.js"></script>
 * @DateTime 2019-02-15
 * @param    {any}   dom       DOM
 * @param    {string}   type      "other" type
 * @param    {object}   paramsObj {url: url ,title: title}
 * @param    {number}   pid       pid
 * @example zhidiao(".xxx", "other", {url: "http://www.58.com",title: "雨桐佩奇"}, 1111);
 */
export const zhidiao = (dom, type, paramsObj, pid) => {
  console.log(dom, type, paramsObj, pid);
  const defaultUrl =
    "wbmain://jump/core/common?params=%7B%22url%22%3A%22https%3A%2F%2Fhrgnode.58.com%2Fzcm%2Fpromotion%22%7D";
  window.callWbApp &&
    window.callWbApp(dom, type, {
      jump: paramsObj.url
        ? "wbmain://jump/core/common?params=" +
        encodeURIComponent(JSON.stringify(paramsObj))
        : defaultUrl,
      pid: pid
    });
};

export function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); 
  var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
  var context = ""; 
  if (r != null) 
     context = r[2]; 
  reg = null; 
  r = null; 
  return context == null || context == "" || context == "undefined" ? "" : context; 
}


export const getQuery = (key, url)  => {
  url = url || window.location.href;
  if (url.indexOf('#') !== -1) url = url.substring(0, url.indexOf('#'));
  let rts = [];
  let rt;
  let queryReg = new RegExp('(^|\\?|&)' + key + '=([^&]*)(?=&|#|$)', 'g');
  while ((rt = queryReg.exec(url)) !== null) {
    rts.push(decodeURIComponent(rt[2]));
  }
  if (rts.length === 0) return null;
  if (rts.length === 1) return rts[0];
  return rts;
}

 export const callApp = () => {
  var p1 = {
    title: "神奇日",
    url: "" + window.location.href + "",
    pagetype: "common",
    loadingtype: "2"
  };
  var params = encodeURIComponent(JSON.stringify(p1));
  window.callWbApp &&
    window.callWbApp("#btn", "other", {
      jump: "wbmain://jump/core/common?params=" + params
    });
};

// 跳转
export function goCommonPage(url,params={}){
	let defaultParam = {
		url,
		isfinish:false, // 销毁当前页，再新开webview
		title:"",
		pagetype:"common",
		settings:{
			hide_title_panel: true,
		}
	}

	for (var p in defaultParam){
		if(defaultParam.hasOwnProperty(p) && (!params.hasOwnProperty(p) ))
			params[p]=defaultParam[p];
	}

	if(isInAPP){
		window.WBAPP.action.pagetrans('core',params);
	}else{
    // callApp()
		window.location.href = url;
	}
}

// 协议跳转
export function newCommonPage(url){
  window.WBAPP.invoke('pagetrans',{
    protocol: url
  })
}

// 动态加载
export function loadJsAsync(url,callback){
	let script = document.createElement('script');
    if (script.readyState) { // IE
        script.onreadystatechange = function () {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
                script.onreadystatechange = null;
                callback();
            }
        } 
    } else { // other
        script.onload = function () {
            callback();
        }
    }
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
}
// app返回上一级
export function goBack(isbacktoroot=false){
	window.WBAPP.invoke("goback", {		
		// "isbacktoroot": isbacktoroot
		is_backtoroot: isbacktoroot
	});
}

export function pageShow(callback){
	if(isInAPP){
		window.WBAPP.invoke('device_event',{
			type:'pageshow' // goback:页面回退时触发；pageshow:页面展示时触发
		},callback);
	}else{
		window.addEventListener('pageshow', callback);
	}
}
const now = Date.now || function() {
  return new Date().getTime();
};
// 防抖函数
export const debounce = (func, wait, immediate) => {
  // immediate默认为false
  var timeout, args, context, timestamp, result;
  var later = function() {
    // 当wait指定的时间间隔期间多次调用_.debounce返回的函数，则会不断更新timestamp的值，导致last < wait && last >= 0一直为true，从而不断启动新的计时器延时执行func
    var last = now() - timestamp;
    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };
  return function() {
    context = this;
    args = arguments;
    timestamp = now();
    // 第一次调用该方法时，且immediate为true，则调用func函数
    var callNow = immediate && !timeout;
    // 在wait指定的时间间隔内首次调用该方法，则启动计时器定时调用func函数
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
};